export default __webpack_public_path__ + "assets/images/1013b267b6845f21c4f480c6e03b424e-icon_consultoria.png";